import { memo } from "react";
import { Flex } from "./flex";
import { Text } from "./text";
import {
  BorderColorValue,
  BorderStyleValue,
  BorderWidthValue,
} from "./theme/box";
import { TextColorValue } from "./theme/typography";

interface OrSeparatorProps {
  borderColor?: BorderColorValue;
  borderStyle?: BorderStyleValue;
  borderWidth?: BorderWidthValue;
  textColor?: TextColorValue;
}

export const OrSeperator = memo(function OrSeperator({
  borderColor = "secondary",
  textColor = "secondary",
  borderWidth = "1px",
  borderStyle = "solid",
}: OrSeparatorProps) {
  return (
    <Flex align="center" justify="center">
      <Flex
        borderColor={borderColor}
        borderStyle={borderStyle}
        borderWidth={borderWidth}
        flex={1}
      />
      <Text textColor={textColor}>OR</Text>
      <Flex
        borderColor={borderColor}
        borderStyle={borderStyle}
        borderWidth={borderWidth}
        flex={1}
      />
    </Flex>
  );
});
